<template>
  <v-layout column>
  <v-flex class="white elevation-2 pt-0">
    <v-toolbar flat dense class="primary" dark>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <slot name="action" />
    </v-toolbar>
    <div class="pl-4 pr-4 pt-2 pb-2">
      <slot>
        {{$t('panel.noSlot')}}
      </slot>
    </div>
  </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: [
    'title'
  ]
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/globals/Panel.vue